import { UPDATE_SPINNER_STATE } from "../actions/types";

const INITIAL_STATE = {
    show: false
};
const SpinnerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_SPINNER_STATE: {
            return {
                ...state,
                show: action.data
            }
        }
        default: return state;
    }
};

export default SpinnerReducer;